"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _intlDesignUi = require("@tencent/intl-design-ui");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  StudentCenterHeader = _require.StudentCenterHeader;
const formatStudentCenterHeader = properties => {
  const paddingTopNum = properties.paddingTopNum,
    paddingBottomNum = properties.paddingBottomNum,
    _properties$anchor = properties.anchor,
    anchor = _properties$anchor === void 0 ? [] : _properties$anchor,
    color = properties.color;
  const anchorList = anchor.map((item, index) => {
    const _item$href = item.href,
      href = _item$href === void 0 ? '' : _item$href,
      _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title;
    return _objectSpread(_objectSpread({}, item), {}, {
      extendProps: {
        'report-event': 'click_StudentCenterHeader_href',
        'report-ext1': index,
        'report-ext2': title,
        'report-ext3': href
      }
    });
  });
  return {
    color,
    paddingTopNum,
    paddingBottomNum,
    anchor: anchorList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  if (Object.keys(data).length > 1) {
    const _formatStudentCenterH = formatStudentCenterHeader(data),
      _formatStudentCenterH2 = _formatStudentCenterH.anchor,
      anchor = _formatStudentCenterH2 === void 0 ? [] : _formatStudentCenterH2,
      paddingTopNum = _formatStudentCenterH.paddingTopNum,
      paddingBottomNum = _formatStudentCenterH.paddingBottomNum,
      _formatStudentCenterH3 = _formatStudentCenterH.color,
      color = _formatStudentCenterH3 === void 0 ? '' : _formatStudentCenterH3;
    const bgStyle = {};
    if (color) {
      bgStyle.background = color;
    }
    const paddingStyle = (0, _componentUtils.doComponentsStyleEvent)({
      paddingTopNum,
      paddingBottomNum
    }); // 处理组件背景色
    paddingStyle.minWidth = 'unset';
    return /*#__PURE__*/React.createElement("div", Object.assign({}, (0, _reportUtil.reportShow)(['show_StudentCenterHeader', componentKey, 'ProductsSpecific']), {
      style: bgStyle
    }), /*#__PURE__*/React.createElement(_intlDesignUi.Section, {
      col: 1,
      style: paddingStyle
    }, /*#__PURE__*/React.createElement(StudentCenterHeader, {
      anchor: anchor,
      isTransform: false,
      inInBanner: false
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}